const META_PIXEL_ID = '1699427804393724'
// Set to null when done testing. Found in Meta Events Manager → Test events tab.
// const META_TEST_EVENT_CODE: string | null = 'TEST11513'
const META_TEST_EVENT_CODE: string | null = null

export function trackLead(params: { email: string; source?: string }) {
  // Fire every available channel independently — a missing one must not block the other.
  trackLeadMeta(params)
  trackLeadGoogle(params)
}

function trackLeadMeta(params: { email: string; source?: string }) {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') {
    return
  }

  try {
    window.fbq('init', META_PIXEL_ID, { em: params.email })

    const customData = { content_name: params.source ?? 'portal_demo' }

    if (META_TEST_EVENT_CODE) {
      window.fbq('track', 'Lead', customData, { eventID: crypto.randomUUID(), test_event_code: META_TEST_EVENT_CODE })
    } else {
      window.fbq('track', 'Lead', customData)
    }
  } catch (e) {
    console.error('Meta lead tracking failed', e)
  }
}

function trackLeadGoogle(params: { email: string; source?: string }) {
  if (typeof window === 'undefined') {
    return
  }

  // Push the lead to dataLayer. GTM (consent-gated) owns the Google Ads
  // conversion tag, triggered by this 'lead' event. The event stays queued
  // in dataLayer until GTM loads after marketing consent.
  window.dataLayer = window.dataLayer || []
  try {
    window.dataLayer.push({
      event: 'lead',
      email: params.email,
      content_name: params.source ?? 'portal_demo',
    })
  } catch (e) {
    console.error('Google (dataLayer) lead tracking failed', e)
  }
}
